import * as React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { applyStoredTheme } from "@/shared/theme";

const MobileApp = React.lazy(() =>
  import.meta.env.VITE_DATA_MODE === "live" ? import("./mc-live-app") : import("./mc-mock-app"),
);

applyStoredTheme();

const host = document.getElementById("root");
if (!host) throw new Error("Корневой узел #root не найден");

createRoot(host).render(
  <React.StrictMode>
    <React.Suspense fallback={<div className="h-dvh bg-background" />}>
      <MobileApp />
    </React.Suspense>
  </React.StrictMode>,
);
